import IsNullOrUndefined from "../utils/ObjectUtils";

export const PriceUtility = {

    calculateSectionTotalPrice: (section) => {
        let sectionTotalPrice = 0;
        section.categories.forEach(category => {
            const currentFeature = category.features.find(feature => feature.id === category.selected_feature);
            if (!IsNullOrUndefined(currentFeature) && !category.disabled) {
                const featurePrice = parseFloat(currentFeature.price);
                if (!isNaN(featurePrice)) {
                    sectionTotalPrice += featurePrice;
                }
            }
        });

        return sectionTotalPrice;
    },

    calculateTotalPrice: (categories) => {
        let total = 0;
        categories.forEach((category) => {
            const currentFeature = category.features.find(feature => feature.id === category.selected_feature);
            const featurePrice = parseFloat(currentFeature.price);

            if (!isNaN(featurePrice)) {
                total += featurePrice;
            }
        });

        return total;
    },

    calculateVatValue: (totalPrice, vatPercentage) => {

        return totalPrice / vatPercentage;
    },

    calculateTotalPriceIncVat: (totalPrice, vatPercentage) => {

        const vatValue = totalPrice / vatPercentage;

        return totalPrice + vatValue;
    },
};
